

module.exports = __webpack_require__.stylable.create(
    "CircularProgressBar3123419115",
    {"classes":{"root":"CircularProgressBar3123419115__root","label":"CircularProgressBar3123419115__label","progressIndicator":"CircularProgressBar3123419115__progressIndicator","indicationIconContainer":"CircularProgressBar3123419115__indicationIconContainer","statusIndicator":"CircularProgressBar3123419115__statusIndicator","arcsContainer":"CircularProgressBar3123419115__arcsContainer","foreArc":"CircularProgressBar3123419115__foreArc","backArc":"CircularProgressBar3123419115__backArc"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    1,
    "CircularProgressBar3123419115",
    null
);
